<template>
  <section class="section full-height">
    <admin-section-header icon="view-grid" title="Community" />
    <div class="tile is-ancestor full-width is-vertical height-100">
      <div class="tile is-parent is-horizontal">
        <dashboard-banner-tile
          :title="$t('Efundation')"
          subtitle=""
          :ctaText="$t('Acceder')"
          ctaTarget="https://efundation.ecobanka.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-08-07-efuntation.jpeg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Ecobanka Careers')"
          :ctaText="$t('Acceder')"
          ctaTarget="https://careers.ecobanka.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-joven-empresario-companeros-trabajo-fondo.jpg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Community ECKN')"
          :ctaText="$t('Acceder')"
          ctaTarget="https://community.ecobanka.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-08-07-Community.png"
        ></dashboard-banner-tile>
      </div>
      <div class="tile is-parent is-4 is-horizontal">
        <dashboard-banner-tile
          :title="$t('Neolicitador Careers')"
          :ctaText="$t('Acceder')"
          ctaTarget="https://neolicitador.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-young-smiling-woman-working-laptop-coworking-office-space-2048x1365.jpg"
        ></dashboard-banner-tile>
      </div>
    </div>
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'Community',
  components: {
    AdminSectionHeader,
    DashboardBannerTile
  },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Community'],
      title: 'Community'
    })
  }
}
</script>

<style lang="scss" scoped>
button.is-large {
  width: max-content;
  height: max-content;
}
.button-grid button {
  margin: 10px 10px;
  border-color: var(--rosa-dark-eco);
}
</style>
